/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import _ from 'lodash';

import { isValidToken } from '../../../../lib/isValidToken';

export default connect(
  (state, ownProps) => {
    const locale = state.localePicker;
    const timezone = moment.tz(state.timezonePicker);
    const region = state.timezonePicker;

    const token = state.token;

    const locales = _.get(state, 'requests.locales.value', undefined);

    const products = (_.get(state, 'requests.products.value', [])).map((i) => ({
      key: i.key,
      url: `/products/${i.key}`,
      order: i.order
    })).sort((a, b) => a.order - b.order)

    products.unshift({
      key: 'All',
      url: '/products/all'
    });

    const currentLocale = locales ? locales.find((l) => l.code === locale) : undefined;

    const props = {
      localeLabel: currentLocale ? currentLocale.name : '',
      timezoneLabel: `${timezone.format('z')} (${timezone.format('Z')} UTC)`,
      loggedIn: isValidToken(token),
      showUnifiedSearchBox: state.globalHeader.showUnifiedSearchBox,
      searchBoxValue: state.globalHeader.searchBoxValue,
      products,
      region,
      locale
    };

    return props;
  },
  (dispatch) => ({
    logout: () => {
      dispatch({
        type: '@@token/Remove'
      });
    },
    showMobileSearch: (show) => {
      dispatch({
        type: '@@globalHeader/SHOW_MOBILE_SEARCH',
        show,
      });
    },
    setSearchBoxValue: (value) => {
      dispatch({
        type: '@@globalHeader/SET_SEARCH_BOX_VALUE',
        value,
      });
    }
  })
);
